import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDossier } from "../../../hooks/useDossier";
import { Dossier } from "../../../models/Dossier";
import { GeoJSON, Pane } from 'react-leaflet';

//Bootstrap
import { Card, InputGroup, Button, Row, Col, Badge, Accordion, Spinner } from "react-bootstrap";
import { useMapInfo } from "../../../hooks/useMapInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faDownload, faEye, faEyeSlash, faHouse, faLocationCrosshairs, faSquare, faSquareFull, faX } from "@fortawesome/free-solid-svg-icons";
import { faSquare as faSquareRegular } from "@fortawesome/free-regular-svg-icons";
import { useCarto } from "../../../hooks/useCarto";
import { useApi } from "../../../hooks/useApi";
import { Feature, FeatureCollection } from "geojson";
import { DomEvent, latLng, Layer } from "leaflet";
import L from "leaflet";
import { TransactionModal } from "./TransactionModal";
import { DocumentsUrbanisme } from "./DocumentsUrbanisme";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

//Params

export const MutationCard = () => {
    /**
     * Hooks
     */
    const { carto, setSelectedCard } = useCarto();
    const divContainer = useRef<HTMLDivElement>(null);

    /**
     * States
     */

    /**
     * Constants
     */
    
    /**
     * useEffect
     */
    useEffect(() => {
        if(divContainer.current) {
            DomEvent.disableScrollPropagation(divContainer.current);
        }
    }, [divContainer, carto.selectedParcelle]);

    /**
     * Handlers
     */
    const handleClose = () => {
        setSelectedCard(null);
    }

    /**
     * Functions
     */

    /**
     * Render
     */
    if(!carto.selectedParcelle) return null;

    return (
        <div ref={divContainer}>
            <Card className="card-cadastre mt-2" style={{ minWidth: '500px', maxHeight: '700px', overflowY: 'auto' }}>
                <Card.Body>
                    <Row>
                        <Col className="d-flex mb-0 justify-content-between">
                            <span>Mutations de la parcelle</span>
                            <div>
                                <FontAwesomeIcon icon={faX} style={{ cursor: 'pointer' }} onClick={handleClose} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mb-1 h3">
                            {carto.selectedParcelle.properties.prefixe} / {carto.selectedParcelle.properties.section} / {carto.selectedParcelle.properties.numero} - {carto.selectedParcelle.properties.contenance} m²
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            {!carto.mutations || carto.mutations?.features?.filter((feature) => {
                                        return feature.properties.cadastre.code == carto.selectedParcelle.properties.code;
                                    }).length == 0 ? (
                                <div className="text-muted">
                                    Aucune mutation trouvée pour cette parcelle
                                </div>
                            ) : (
                                <>
                                    {carto.mutations?.features?.filter((feature) => {
                                        return feature.properties.cadastre.code == carto.selectedParcelle.properties.code;
                                    }).map((feature) => {
                                        return (
                                            <div className="p-3 bg-light border border-dark-subtle rounded mb-2">
                                                <div key={feature.properties.id} style={{ width: '100%' }}>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-bold fs-5">{feature.properties.nature}</span>
                                                        <span className="fs-5">{feature.properties.valeurFonciere.toLocaleString()} €</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span><FontAwesomeIcon icon={faCalendar} /> {feature.properties.dateMutation?new Date(feature.properties.dateMutation).toLocaleDateString('fr-FR'):null}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between mt-2">
                                                        <span>{feature.properties.typeLocal}</span>
                                                        <span><FontAwesomeIcon icon={faHouse} /> {feature.properties.surfaceBatiment?feature.properties.surfaceBatiment.toLocaleString():'-'} m²</span>
                                                        <span><FontAwesomeIcon icon={faSquare} /> {feature.properties.surfaceTerrain?feature.properties.surfaceTerrain.toLocaleString():'-'} m²</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}
